<template>
  <div>
    <notify/>
    <v-overlay :value="showOverlay" z-index="7">
      <div class="d-flex flex-column align-center pa-12">
        <v-progress-circular
          indeterminate
          size='64'
        ></v-progress-circular>
        <div class="pt-5">
          <span class="overlay-text">{{ overlayText }}</span>
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import Notify from '@/components/Notify'
export default {
  components: {
    Notify
  },
  computed: {
    showOverlay() {
      return this.$store.state.general.showModal
    },
    overlayText() {
      return this.$store.state.general.overlayText
    }

  }
}
</script>
<style lang="scss">
  .overlay-text {
    font-family: Roboto, sans-serif;
  }
</style>